export default __webpack_public_path__ + "static/media/ic_arrow_up_dark.d526aa02.svg";